module.exports = __webpack_public_path__ + "img/cHMxNHBF.dfe764fe.svg";